import React from 'react';

import './Button.scss';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonUnstyled from '@mui/base/ButtonUnstyled';

function MenuButton  ({children, className,items}) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const listItems = items.map((item) =>
      <MenuItem onClick={item.onClick} >{item.option}</MenuItem>
    );


    return (
        <>
            <ButtonUnstyled className={className ? className :"primary-button"} aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>{ children }</ButtonUnstyled>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
            >
                {listItems}
            </Menu>
        </>
    );
}

export default MenuButton;